import { Link } from 'react-router-dom'
import { Botao } from '../../../components/Botao'
import { IconeImprimir } from '../../../components/Icones'
import { TEXTOS } from '../../../lib/glossario'
import { competenciaPorExtenso } from '../competencia'

/**
 * O caminho do fechamento até o termo de recebimento.
 *
 * **Fechada é `<Link>`; aberta é `<Botao disabled>`, e a troca de elemento é necessária, não
 * estilo.** Link "desabilitado" não existe em HTML: `aria-disabled` num `<a href>` continua
 * navegando, e `<a><button/></a>` é markup inválido que o leitor de tela anuncia como dois
 * controles. Quando não há para onde ir, o elemento certo é o botão desligado — com a explicação
 * ao lado, porque um botão cinza sem motivo vira chamado no suporte.
 *
 * @param props a competência e o estado dela
 * @returns o link ou o botão desabilitado, com a explicação
 */
export function LinkDoTrp({ competencia, fechada }: { competencia: string; fechada: boolean }) {
  const t = TEXTOS.trp

  if (fechada) {
    return (
      <Link
        to={`/relatorios/trp/${competencia}`}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-niteroi-700 ring-1 ring-inset ring-slate-300 hover:bg-slate-50"
      >
        <IconeImprimir className="h-4 w-4" />
        {t.emitir}
        <span className="sr-only">(abre em outra aba)</span>
      </Link>
    )
  }

  return (
    <div>
      <Botao disabled>
        <IconeImprimir className="h-4 w-4" />
        {t.emitir}
      </Botao>
      <p className="mt-1 max-w-prose text-sm text-slate-600">
        {t.soFechada.ajuda(competenciaPorExtenso(competencia))}
      </p>
    </div>
  )
}
